<script>
import Modal from "@/components/modals/modal-form.vue";
import PreviewForm from "./partials/preview-form.vue";
import PreviewResults from "./partials/preview-results.vue";

export default {
    emits: ['onSuccess'],
    props: {
        modalId: String,
        id: Number,
    },
    data() {
        return {
            previewResults: null,
            isLoading: false,
            hasError: false
        }
    },
    components: {
        Modal,
        PreviewForm,
        PreviewResults
    },
    computed: {
        modalTilte(){
            return `Previsualización de HotelBeds`;
        },
    },
    methods: {
        shown() {
            // Reset results when modal is shown
            this.previewResults = null;
            this.isLoading = false;
            this.hasError = false;
        },
        cancel() {
            this.$bvModal.hide(this.modalId);
        },
        handlePreviewResults(results) {
            this.previewResults = results;
            this.isLoading = false;
        },
        handlePreviewStart() {
            this.isLoading = true;
            this.previewResults = null;
            this.hasError = false;
        },
        handlePreviewError() {
            this.isLoading = false;
            this.previewResults = null;
            this.hasError = true;
        }
    }
};
</script>

<template>
    <div>
        <Modal 
            :title="modalTilte" 
            :id="modalId" 
            @cancel="cancel" 
            @shown="shown" 
            :size="'extra-xl'" 
            :showConfirmButton="false" 
            :label-cancel-btn="'Cerrar'"
        >
            <div class="row">
                <!-- Form Column -->
                <div class="col-md-3">
                    <PreviewForm 
                        :integration-id="id"
                        @preview-results="handlePreviewResults"
                        @preview-start="handlePreviewStart"
                        @preview-error="handlePreviewError"
                    />
                </div>
                
                <!-- Results Column -->
                <div class="col-md-9">
                    <PreviewResults 
                        :results="previewResults"
                        :loading="isLoading"
                        :has-error="hasError"
                    />
                </div>
            </div>
        </Modal>
    </div>    
</template>